import Vue from 'vue'
import VueRouter from 'vue-router'

import routesBack from './routes-backend'
import routesFront from './routes-frontend'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes: [...routesFront, ...routesBack],
  scrollBehavior: (to) => {
    if (to.hash) {
      return { selector: to.hash }
    } else {
      return { x: 0, y: 0 }
    }
  },
  linkExactActiveClass: 'nav-item active',
})

export default router
